import { useCallback, useEffect, useState } from 'react'
import PropTypes from 'prop-types'
import { Button, Table } from 'antd'
import LoadingGif from '../LoadingGif'
import SearchBox from '../SearchBox/SearchBox'
import AddEditBoothModal from './AddEditBoothModal'
import './BoothCompaniesList.less'

const { Column } = Table

const BoothCompaniesList = ({
  setTableParameters,
  companiesAndBooths,
  loading,
}) => {
  const [selectedCompany, setSelectedCompany] = useState(null)
  const [isModalVisible, setIsModalVisible] = useState(false)
  const [tableData, setTableData] = useState(companiesAndBooths)
  const handleSearch = useCallback(
    (value) => {
      const newParameters = {
        pagination: {},
        filters: {},
        sorter: {},
        searchTerm: { SearchValue: value },
      }
      setTableParameters(newParameters)
    },
    [setTableParameters]
  )

  useEffect(() => {
    setTableData(companiesAndBooths)
  }, [companiesAndBooths])

  const showModal = (company) => {
    setSelectedCompany(company)
    setIsModalVisible(true)
  }

  const handleOk = (updatedCompany) => {
    setTableData((prevData) =>
      prevData.map((company) =>
        company.eventCompanyId === updatedCompany.eventCompanyId
          ? { ...company, boothName: updatedCompany.boothName }
          : company
      )
    )
    setIsModalVisible(false)
    setSelectedCompany(null)
  }

  const handleCancel = () => {
    setIsModalVisible(false)
    setSelectedCompany(null)
  }

  return (
    <LoadingGif spinning={loading}>
      <div>
        <SearchBox
          className="boothCompaniesList-searchBar"
          onSearch={handleSearch}
          allowClear={true}
        />
        <Table
          dataSource={tableData}
          className="cc-company-colleagues-table"
          rowKey={(record) => record.eventCompanyId.toString()}
        >
          <Column
            title="Company Name"
            dataIndex="company.name"
            key="company.name"
            sorter={(a, b) => a.company.name.localeCompare(b.company.name)}
          />
          <Column
            title="Booth Name"
            dataIndex="boothName"
            key="boothName"
            sorter={(a, b) =>
              a.boothName
                ? a.boothName.localeCompare(b.boothName)
                : ''.localeCompare(b.boothName)
            }
          />
          <Column
            title="Action"
            key="addBooth"
            render={(text, record) => (
              <>
                {record.eventboothId && (
                  <Button type="primary" onClick={() => showModal(record)}>
                    Add Booth
                  </Button>
                )}
              </>
            )}
          />
        </Table>
        {selectedCompany && (
          <AddEditBoothModal
            visible={isModalVisible}
            handleOk={handleOk}
            handleCancel={handleCancel}
            companyBooth={selectedCompany}
          />
        )}
      </div>
    </LoadingGif>
  )
}
BoothCompaniesList.propTypes = {
  eventId: PropTypes.number,
  companiesAndBooths: PropTypes.array.isRequired,
  setTableParameters: PropTypes.func.isRequired,
  loading: PropTypes.bool.isRequired,
}
export default BoothCompaniesList
